import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Шрифты: self-hosted woff2 через fontsource, только нужные сабсеты/веса.
// Golos Text — весь UI (кириллица); IBM Plex Mono — денежные суммы.
import '@fontsource/golos-text/cyrillic-400.css';
import '@fontsource/golos-text/cyrillic-500.css';
import '@fontsource/golos-text/cyrillic-600.css';
import '@fontsource/golos-text/latin-400.css';
import '@fontsource/golos-text/latin-500.css';
import '@fontsource/golos-text/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/ibm-plex-mono/latin-600.css';
import '@fontsource/ibm-plex-mono/cyrillic-400.css';
import '@fontsource/ibm-plex-mono/cyrillic-500.css';
import '@fontsource/ibm-plex-mono/cyrillic-600.css';
import { App } from './App';
import {
  applyTelegramTheme,
  applyViewportInsets,
  enterFullscreen,
  getWebApp,
} from './lib/telegram';
import { ViewCurrencyProvider } from './lib/view-currency';
import './styles.css';

// ready() до всего остального: пока он не вызван, клиент считает приложение
// незагруженным и часть API молчит.
getWebApp()?.ready();
enterFullscreen();
applyViewportInsets();
applyTelegramTheme();

import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './lib/toast';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Mini App нечасто открывают надолго — переcheck при focus достаточно.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    {/* Граница ошибок — снаружи всего: исключение в провайдере данных тоже
        должно давать экран отказа, а не пустоту. */}
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ViewCurrencyProvider>
          {/* Тост поверх приложения: отказ операции обязан быть виден. */}
          <ToastProvider>
            <App />
          </ToastProvider>
        </ViewCurrencyProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
